export default __webpack_public_path__ + "static/preposition-6739b870625f9067cbfe0ecb116dfe64.png";